import { render, staticRenderFns } from "./AttachmentManager.vue?vue&type=template&id=1b573500&scoped=true"
import script from "./AttachmentManager.vue?vue&type=script&lang=js"
export * from "./AttachmentManager.vue?vue&type=script&lang=js"
import style0 from "./AttachmentManager.vue?vue&type=style&index=0&id=1b573500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b573500",
  null
  
)

export default component.exports